import { render, staticRenderFns } from "./FormLayoutGrades.vue?vue&type=template&id=fc12ecb4&scoped=true"
import script from "./FormLayoutGrades.vue?vue&type=script&lang=js"
export * from "./FormLayoutGrades.vue?vue&type=script&lang=js"
import style0 from "./FormLayoutGrades.vue?vue&type=style&index=0&id=fc12ecb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc12ecb4",
  null
  
)

export default component.exports